import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-leo-ai-points",
  "use": "icon-soc-l1-leo-ai-points-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-leo-ai-points\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 224h640v96H192V224zm64 128h512v448H256V352zm96 80v64h320v-64H352zm0 128v64h296v-64H352z\" />\r\n  <path d=\"M320 848h384v48H320v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-leo-ai-points.svg
// module id = hMeV
// module chunks = 477